/** Created by azhou on 2019/4/26.*/
<template>
    <div>
      <public-title showBack>{{proId>0 ? '编辑' : '添加'}}产品</public-title>
      <div class="load-area text-left">
        <left-text leftText="产品主标题" class="mb-2"/>
        <el-input size="small" v-model="ProductInfo.title" class="ml-2 mb-2"/>
        <left-text leftText="产品副标题" class="mb-2"/>
        <el-input size="small" v-model="ProductInfo.description" class="ml-2"/>
        <left-text leftText="省/市/区" class="mb-2 mt-5"/>
        <select-city @getCityInfo="info => getCityInfo(info,'parent')"
          :provinceId="ProductInfo.province"
          :cityId="ProductInfo.city"
          :districtId="ProductInfo.district" />
        <left-text leftText="产品类型" class="mb-2 mt-5"/>
        <el-radio v-model="radio" label="1">限时优惠</el-radio>
        <el-radio v-model="radio" label="2">限时抢购</el-radio>
        <left-text leftText="使用日期" class="mb-2 mt-5"/>
        <el-date-picker v-model="timestamp"
                        class="ml-2" size="small"
                        type="daterange"
                        range-separator="至"
                        value-format="timestamp"
                        start-placeholder="开始时间"
                        end-placeholder="结束时间" />
        <div v-show="randio">
          <left-text leftText="可买日期" class="mb-2 mt-5"/>
          <div class="ml-2">
            <span class="date-tag" v-for="item in dateArr" :key="item.id"
                  @click="item.checked = !item.checked"
                  :class="{active:item.checked}">{{item.name}}</span>
          </div>
        </div>
        <!--<left-text leftText="优惠价格" class="mb-2 mt-5"/>
        <el-input v-model.number="ProductInfo.discount" class="w-40 ml-2" type="number">
          <span slot="append">元</span>
        </el-input>-->
        <left-text leftText="产品图片" class="mb-2 mt-5"/>
        <upload-image @fileChange="(imgs)=>{this.InsideImgs = imgs;}" class="ml-2"
                      :existImgs="InsideImgs" :maxLength="5" editMode/>
        <left-text leftText="分享图片" class="mb-2 mt-5"/>
        <upload-image @fileChange="(imgs)=>{this.adImgs = imgs;}" class="ml-2"
                      :existImgs="adImgs" :maxLength="1" editMode/>
        <left-text leftText="主题特色" class="mb-2 mt-4"/>
        <el-tag :key="index + 'tag'"
          class="ml-2"
          v-for="(tag,index) in dynamicTags"
          closable
          :disable-transitions="false"
          @close="handleClose(tag)">
          {{tag}}
        </el-tag>
        <el-input class="w-10 ml-2"
          v-if="inputVisible"
          v-model="inputValue"
          ref="saveTagInput"
          size="small"
          @keyup.enter.native="handleInputConfirm"
          @blur="handleInputConfirm" />
        <el-button v-else class="ml-2" size="small" @click="showInput">+ 添加标签</el-button>
        <p class="text-muted ml-2 mt-2 mb-2" v-if="tagAddedArr.length>0">历史标签库</p>
        <el-tag type="success" v-for="tag in tagAddedArr" size="small"
                @click.native="() => dynamicTags.push(tag.tag)"
                :key="tag.id" class="ml-2 cursor-pointer">{{tag.tag}}</el-tag>
        <div class="d-center-start mt-5">
          <left-text leftText="门店信息" />
          <el-button type="primary"  class="ml-2" size="small" @click="dialogVisible = true">添加门店</el-button>
        </div>
        <el-dialog
          title="添加门店信息"
          :visible.sync="dialogVisible"
          width="80%">
          <el-tabs v-model="activeName" type="card" @tab-click="handleClick">
            <el-tab-pane label="酒店" name="3" />
            <el-tab-pane label="民宿" name="5" />
            <el-tab-pane label="景区" name="6" />
          </el-tabs>
          <div class="diaoHeight mt-5">
            <div class="mr-5 w-50 dropCon">
              <el-select
                class="w-80"
                v-model="sonName"
                filterable
                remote
                reserve-keyword
                @change="storeChoose"
                placeholder="请输入关键词"
                :remote-method="remoteMethod">
                <el-option
                    v-for="item in AdminDataLists.lists"
                    :key="item.id"
                    :label="item.title"
                    :value="item.id">
                </el-option>
              </el-select>
            </div>
            <el-input type="number" class="w-40 mr-5 text-right" placeholder="请输入成本价" v-model.number="accountPrice">
              <template slot="prepend">成本价：</template>
            </el-input>
            <div v-if="sonAddressInfo.info">
              <div class="mt-3 mb-3 mr-3 text-right" @click="mapShow = !mapShow">
                <span class="text-link mr-5">{{area}}</span>
                <span class="text-link">展开/收起地图</span>
              </div>
              <el-tabs v-model="sonactiveName" type="border-card" class="mr-3" v-if="radioShow">
                <el-tab-pane :label="'酒店房型'+sonAddressInfo.room_arr.length+'种'" name="1" v-if="activeName == '3'">
                  <el-radio-group v-model="radioHotel">
                    <el-radio class="w-50 pt-3 pb-3 border-bottom" ref="ref" :label="item" v-for="(item,index) in sonAddressInfo.room_arr" :key="index">{{item.title}}</el-radio>
                  </el-radio-group>
                </el-tab-pane>
                <el-tab-pane :label="'酒店会议室（'+sonAddressInfo.meeting_arr.length+'种）'" name="2" v-if="activeName == '3'">
                  <el-radio-group v-model="radioHotel">
                    <el-radio class="w-50 pt-3 pb-3 border-bottom" :label="item" v-for="(item,index) in sonAddressInfo.meeting_arr" :key="index">{{item.title}}</el-radio>
                  </el-radio-group>
                </el-tab-pane>
                <el-tab-pane :label="'民宿房型（'+sonAddressInfo.room_arr.length+'种）'" name="4" v-if="activeName == '5'">
                  <el-radio-group v-model="radioStay">
                    <el-radio class="w-50 pt-3 pb-3 border-bottom" :label="item" v-for="(item,index) in sonAddressInfo.room_arr" :key="index">{{item.title}}</el-radio>
                  </el-radio-group>
                </el-tab-pane>
                <el-tab-pane :label="'民宿活动（'+sonAddressInfo.onsale_arr.onsale_nums+'种）'" name="5" v-if="activeName == '5'">
                  <el-radio-group v-model="radioStay">
                    <el-radio class="w-50 pt-3 pb-3 border-bottom" :label="item" v-for="(item,index) in sonAddressInfo.onsale_arr.onsale_list" :key="index">{{item.title}}</el-radio>
                  </el-radio-group>
                </el-tab-pane>
                <el-tab-pane :label="'景区门票（'+sonAddressInfo.ticket_arr.ticket_nums+'种）'" name="3" v-if="activeName == '6'">
                  <el-radio-group v-model="radioScenic">
                    <el-radio class="w-50 pt-3 pb-3 border-bottom" :label="item" v-for="(item,index) in sonAddressInfo.ticket_arr.ticket_list" :key="index">{{item.name}}</el-radio>
                  </el-radio-group>
                </el-tab-pane>
              </el-tabs>
              <div v-show="mapShow" id="allmap"></div>
              <!-- <b-map class="ml-3 mr-3 mt-3"
                    v-show="mapShow"
                    suggestId="inputTitle"
                    eleHeight="300"
                    :markPoint="storePoint" /> -->
            </div>
          </div>
          <span slot="footer" class="dialog-footer">
            <el-button @click="dialogVisible = false">取 消</el-button>
            <el-button type="primary" @click="addProductSon">确定添加</el-button>
          </span>
        </el-dialog>
        <el-table  :data="ProductInfo.son"  class="w-100 mt-2" v-show="ProductInfo.son.length>0">
          <el-table-column  label="门店"  width="180">
            <template slot-scope="scope">
              {{scope.row.store_type | parentFType}}
            </template>
          </el-table-column>
          <el-table-column  prop="name"  label="名称"  width="180" />
          <el-table-column  label="成本价">
            <template slot-scope="scope">{{scope.row.price4}}&nbsp;元</template>
          </el-table-column>
          <el-table-column  label="类型">
            <template slot-scope="scope">
              {{scope.row.son_type | sonFType}}
            </template>
          </el-table-column>
          <el-table-column  prop="son_name"  label="" />
          <el-table-column label="操作">
            <template slot-scope="scope">
              <span class="text-link" @click="ProductInfo.son.splice(scope.$index, 1)">删除</span>
            </template>
          </el-table-column>
        </el-table>
        <!-- <div class="d-center mt-5">
          <left-text-border leftText="酒店/民宿/景区"
                            inputId="inputTitle"
                            class="w-40"
                            v-model="sonName"/>
          <select-city class="ml-auto w-50"
                       leftText="省市区"
                       @getCityInfo="info => getCityInfo(info,'son')"
                       :provinceId="sonAddressInfo.province"
                       :cityId="sonAddressInfo.city"
                       :districtId="sonAddressInfo.district"/>
          <span class="text-link ml-3" @click="addProductSon">添加</span>
        </div>
        <el-tag v-for="(tag,index) in ProductInfo.son" :key="index + 'son'"
                @close="tag => ProductInfo.son.splice(index, 1)"
                closable type="success" class="ml-2 mt-2">
          {{tag.name}}
        </el-tag>
        <b-map class="ml-2 mt-3"
               suggestId="inputTitle"
               eleHeight="400"
               @onConfirm="point => getCityInfo(point, 'son')"
               @setAddToPoint="point => this.lonLatInfo = point"
               @setStoreTitle="(v)=>this.sonName = v"
               :WheelZoom="false"
               :markPoint="storePoint"
               :MapArea="MapArea"/> -->
        <left-text leftText="产品价格" class="mb-2 mt-5"/>
        <div class="mb-3 priceTitle">
          <label><span>星期日</span>至<span>星期四(非周末)：</span></label>
          <el-input placeholder="请输入内容" size="small" :disabled="item.value == 'price4'" v-model="ProductInfo[item.value]" v-for="item in priceArr" :key="item.value">
            <template slot="prepend">{{item.title}}</template>
          </el-input>
        </div>
        <div class="priceTitle">
          <label><span>星期五</span>至<span>星期六(周末)：</span></label>
          <el-input placeholder="请输入内容" size="small" v-model="ProductInfo[item.value]" v-for="item in priceWeekend" :key="item.value">
            <template slot="prepend">{{item.title}}</template>
          </el-input>
         </div>
          <!-- <div class="d-center-around mb-2 text-right"
               v-for="item in priceArr" :key="item.value">
            <left-text :leftText="item.title"/>
            <div class="bg-white">
              <span class="text-blue border-right pl-2 pr-2 mr-1">&yen;</span>
              <input type="number" class="price-input" :disabled="item.value == 'price4'" v-model="ProductInfo[item.value]">
              <span class="price-label p-2">元 / 人</span>
            </div>
          </div>
          <label><span>星期五</span>至<span>星期六(周末)</span></label>
          <div class="d-center-around mb-2 text-right"
               v-for="item in priceArr" :key="item.value">
            <left-text :leftText="item.title"/>
            <div class="bg-white">
              <span class="text-blue border-right pl-2 pr-2 mr-1">&yen;</span>
              <input type="number" class="price-input" :disabled="item.value == 'price4'" v-model="ProductInfo[item.value]">
              <span class="price-label p-2">元 / 人</span>
            </div>
          </div> -->
        <left-text leftText="套餐包含" class="mb-2 mt-5"/>
        <rich-editor class="w-100" v-model="ProductInfo.description3" :contentProps="ProductInfo.description0" :allowUploadImg="false" editorId="editor2" />
        <left-text leftText="购买须知" class="mb-2 mt-5"/>
        <rich-editor class="w-100" v-model="ProductInfo.description1" :contentProps="ProductInfo.description1" :allowUploadImg="false" editorId="editor1"/>
        <left-text leftText="特色介绍" class="mb-2 mt-5"/>
        <rich-editor class="w-100 special" v-model="ProductInfo.description2" :nums="nums" :contentProps="ProductInfo.description2" @change="change" />
        <div class="text-center">
          <el-button @click="submitForm" class="mt-4 w-25 btn-login">确定添加</el-button>
        </div>
      </div>
    </div>
</template>

<script>
  import { mapGetters, mapActions,mapState, mapMutations } from 'vuex'
  import { UploadImages } from '@/assets/utils/uploadFiles'
  //import BMap from '../../../components/BMap/BMap'
  import RichEditor from '../../../components/Editor/RichEditor'

  export default {
    name: 'AddEditProduct',
    components: { RichEditor },
    computed: {
      ...mapState(['AdminDataDetail','AdminDataLists']),
      ...mapGetters(['storeInfo']),
      proId() { return this.$route.query.proId },
      storePoint () {      //传入给BMap组件的门店经纬度地址信息，默认公司地址
        return [{
          lng: this.sonAddressInfo.info.longitude > 0 ? this.sonAddressInfo.info.longitude : 120.206194,
          lat: this.sonAddressInfo.info.latitude > 0 ? this.sonAddressInfo.info.latitude : 30.291275,
          IconPng: require('../../../../public/images/public/icon.png')
        }]
      },
      MapArea () {     //传入给BMap组件的区域地址信息
        return {
          province: this.sonAddressInfo.province_name,
          city: this.sonAddressInfo.city_name,
          district: this.sonAddressInfo.district_name,
          address: this.sonAddressInfo.address
        }
      },
      priceFour () {
        return this.ProductInfo.son
      },
      mapSon () {
        return this.sonAddressInfo.info
      }
    },
    watch:{
      //开始和结束时间戳
      timestamp (newVal) {
        this.ProductInfo.date_in = newVal[0] / 1000
        this.ProductInfo.date_out = newVal[1] / 1000
      },
      radio (newVal) {
        if (newVal == '1') {
          this.randio = true
        } else {
          this.randio = false
        }
      },
      priceFour () {
        this.ProductInfo.price4 = 0
        let price = this.ProductInfo.son.map(item => { return item.price4 })
        price.forEach((item) => { this.ProductInfo.price4 += Number(item) })
      },
      mapSon () {
        this.$nextTick(_ => {
          this.initMap()
        })
      }
    },
    data() {
      return {
        ProductInfo:{
          son:[]
        },
        timestamp:'',
        dateArr:[
          {id:'1',name:'周一',checked:true},{id:'2',name:'周二',checked:true},{id:'3',name:'周三',checked:true},
          {id:'4',name:'周四',checked:true},{id:'5',name:'周五',checked:true},
          {id:'6',name:'周六',checked:true}, {id:'7',name:'周日',checked:true},
        ],
        InsideImgs:[],            //产品图片
        adImgs:[],                //推广图片
        inputVisible: false,
        inputValue: '',
        dynamicTags: [],
        tagAddedArr:[],
        priceArr:[
          { title: '原价', value: 'price1' },
          { title: '抢购价(散客)', value: 'price2' },
          { title: '结算价(门店)', value: 'price3' },
          { title: '成本总计', value: 'price4' }
        ],
        priceWeekend:[
          { title: '原价', value: 'weekend_price1' },
          { title: '抢购价(散客)', value: 'weekend_price2' },
          { title: '结算价(门店)', value: 'weekend_price3' },
        ],
        sonName:'',
        sonAddressInfo:{},
        radio: '1',
        randio: true,
        lonLatInfo: {
          longitude: 120.206194,
          latitude: 30.291275
        },
        dialogVisible: false,
        activeName: '3',
        sonactiveName: '1',
        accountPrice: '',
        mapShow: true,
        radioShow: false,
        radioStay: '',
        radioHotel: '',
        radioScenic: '',
        area: '',
        loading: false,
        nums: 0
      }
    },
    async created() {
      //获取历史标签库
      this.tagAddedArr = await this.getProductTags();
      //获取产品详情
      if (this.proId) {
        await this.getItemDetail({
          type:'productDetail',
          data:{product_id:this.proId}
        })
        this.formatDetail();
      }
    },
    filters: {
      parentFType: val => {
        switch (Number(val)) {
          case 3: return '酒店'; break;
          case 5: return '民宿'; break;
          case 6: return '景区'; break;
        }
      },
      sonFType: val => {
        switch (Number(val)) {
          case 1: return '酒店房型'; break;
          case 2: return '酒店会议室'; break;
          case 4: return '民宿房型'; break;
          case 5: return '民宿活动'; break;
          case 3: return '景区门票'; break;
        }
      }
    },
    methods:{
      ...mapMutations(['UPDATECURRENTSTORE']),
      ...mapActions(['getProductTags','addProduct','getItemDetail','editProduct','getAdminDataLists']),
      // 富文本编辑器父子组件传参
      change(val) {
        this.$nextTick(_ => {
          this.ProductInfo.description2 = val
        })
      },
      /*获取酒店、景区、民宿列表*/
      getLists (name) {
        // this.UPDATECURRENTSTORE({type:Number(this.activeName)});
        this.getAdminDataLists({
          type:'storeList',
          data:{
            name,
            storeType:Number(this.activeName),
            num:10,
          }
        });
      },
      /**禁止鼠标滚动地图 */
      initMap () {
        var map = new BMap.Map('allmap');            // 创建Map实例
        let point = new BMap.Point(this.sonAddressInfo.info.longitude, this.sonAddressInfo.info.latitude);
        map.addControl(new BMap.MapTypeControl());
        map.addControl(new BMap.NavigationControl());//添加默认缩放平移控件
        map.centerAndZoom(point,15);  //初始化时，即可设置中心点和地图缩放级别
        let marker = new BMap.Marker(point);
        map.addOverlay(marker);
        let displayTitle = this.sonAddressInfo.info.title || '';
        var label = new BMap.Label(displayTitle, {offset: new BMap.Size(20, -10)});
        marker.setLabel(label);
        map.enableDoubleClickZoom(true);
      },
      /**远程搜索选择门店 */
      remoteMethod(query) {
        if (query !== '') {
          this.getLists(query)
        } else {
          this.AdminDataLists.lists = []
        }
      },
      // 下拉选择门店
      async storeChoose (selVal) {
        let res = await this.$axios.post('/pc/Admin/HotelDetail',{
          store_id: selVal,
          store_type: this.activeName,
          is_get_store_user_arr: '0',
          is_get_room_arr: '1',
          is_get_bankcard_count: '0',
          is_get_invoice_count: '0',
          is_get_order_arr: '0',
          is_get_ticket_list: '1',
          is_get_onsale_list: '1'
        });
        if (res.code === '00000') {
          this.sonAddressInfo = res
          this.radioShow = true
          this.area = res.info.province_name + '省' + res.info.city_name + '市' + res.info.district_name
        }
      },
      // 酒店、民宿、景区切换时子级对应不同的tab以及更新数据
      handleClick (tab) {
        this.sonName = ''
        this.AdminDataLists.lists = []
        this.radioShow = false
        this.area = ''
        if (this.activeName == '3') {
          this.sonactiveName = '1'
        } else if (this.activeName == '5') {
          this.sonactiveName = '4'
        } else {
          this.sonactiveName = '3'
        }
      },
      /*获取省市区id和name*/
      getCityInfo (info,type) {
        switch (type) {
          case 'parent':                //整个套餐的省市区位置信息
            for (let key in info) {
              this.$set(this.ProductInfo,key,info[key]);
            }
            break;
          case 'son':                   //套餐内某一酒店/民宿/景区等的省市区位置信息
            for (let key in info) {
              this.$set(this.sonAddressInfo,key,info[key]);
            }
            break;
        }
      },
      /*添加酒店/民宿/景区等到套餐中*/
      addProductSon() {
        if (!this.accountPrice) {
          this.$message.warning('请输入成本价')
          return
        } else if (this.activeName == '3' && !this.radioHotel || this.activeName == '5' && !this.radioStay || this.activeName == '6' &&!this.radioScenic) {
          this.$message.warning('请选择酒店、民宿或景区')
          return
        }
        this.dialogVisible = false
        let son_name,son_id
        if (this.activeName == '3') {
          son_name = this.radioHotel.title
          son_id = this.radioHotel.id
        } else if (this.activeName == '5') {
          son_name = this.radioStay.title
          son_id = this.radioStay.id
        } else {
          son_name = this.radioScenic.name
          son_id = this.radioScenic.id
        }
        this.ProductInfo.son.push({
          name:this.sonAddressInfo.info.title,
          store_id: this.sonAddressInfo.info.id,
          store_type: this.activeName,
          province: this.sonAddressInfo.info.province,
          city:this.sonAddressInfo.info.city,
          district:this.sonAddressInfo.info.district,
          longitude:this.sonAddressInfo.info.longitude,
          latitude:this.sonAddressInfo.info.latitude,
          son_name,
          son_id,
          son_type: this.sonactiveName,
          price4: this.accountPrice
        })
      },
      //套餐标签主题的删除
      handleClose(tag) {
        this.dynamicTags.splice(this.dynamicTags.indexOf(tag), 1);
      },
      //编辑时整理产品信息
      formatDetail() {
        this.ProductInfo = {
          ...this.AdminDataDetail,
        }
        this.timestamp = [this.AdminDataDetail.date_in * 1000,this.AdminDataDetail.date_out * 1000];
        this.dateArr.forEach(v => {
          v.checked = this.AdminDataDetail.buy_time.indexOf(v.id) !== -1;
        });
        this.InsideImgs = this.AdminDataDetail.pic.split(',');
        this.adImgs = this.AdminDataDetail.ad_pic;
        this.dynamicTags = this.AdminDataDetail.tag_arr.map(v => v.tag);
        this.radio = String(this.AdminDataDetail.type)
      },
      /*验证表单*/
      validateForm() {
        if (!this.ProductInfo.title)  return { code: false, msg: '请填写产品套餐主标题' }
        if (!this.ProductInfo.description)  return { code: false, msg: '请填写产品套餐副标题' }
        if (!this.ProductInfo.district) return { code: false, msg: '请选择套餐所属省市区' }
        if (!this.timestamp) return { code: false, msg: '请设置套餐使用日期' }
        // if (!this.$GFUN.isMoneyRight(this.ProductInfo.discount)) return { code: false, msg: '请设置正确的优惠价格' }
        if (this.InsideImgs.length <= 0) return { code: false, msg: '请至少上传一张活动图片' }
        if (this.adImgs.length <= 0) return { code: false, msg: '请上传推广图片' }
        if (this.dynamicTags.length <= 0) return { code: false, msg: '请至少添加一项主题特色' }
        if (this.ProductInfo.son.length <= 0) return { code: false, msg: '请至少添加一项酒店/民宿/景区等主体' }
        for (let i = 0; i < this.priceArr.length; i++) {
          if (!this.$GFUN.isMoneyRight(this.ProductInfo[this.priceArr[i].value]))
            return { code: false, msg: '请设置正确的非周末套餐价格' }
        }
        for (let i = 0; i < this.priceWeekend.length; i++) {
          if (!this.$GFUN.isMoneyRight(this.ProductInfo[this.priceWeekend[i].value]))
            return { code: false, msg: '请设置正确的周末套餐价格' }
        }
        if (!this.ProductInfo.description1)  return { code: false, msg: '请填写产品套餐购买须知' }
        if (!this.ProductInfo.description2) return { code: false, msg: '请选择套餐特色介绍' }
        if (!this.ProductInfo.description3) return { code: false, msg: '请填写套餐包含内容' }
        return { code: true, msg: '验证通过' }
      },
      //提交表单
      submitForm() {
        let res = this.validateForm();
        this.nums = Number(sessionStorage.getItem('cnum')) + 1
        if (res.code) {
          this._confirm('确定提交么？',async () => {
            //可使用日期
            let weekArr = this.dateArr.filter(v => v.checked).map(v => v.id)
            this.ProductInfo.buy_time = weekArr.join(',');
            //套餐图片
            this.ProductInfo.pic = (await UploadImages(this.InsideImgs)).join(',');
            //推广图片
            this.ProductInfo.ad_pic = (await UploadImages(this.adImgs))[0];
            //富文本编辑器上传图片
            this.ProductInfo.description2 = await this.$GFUN.formatEditor(this.ProductInfo.description2)
            //主题标签
            this.ProductInfo.tags = this.dynamicTags.join(',');
            if (this.proId) {     //编辑产品信息
              delete this.ProductInfo.tag_arr;      //删除标签组
              this.editProduct({
                data:{
                  ...this.ProductInfo,
                  product_id:this.proId,
                  type: this.radio
                }
              })
            } else {              //添加产品到服务器
              this.addProduct({
                ...this.ProductInfo,
                main_id:this.$route.query.mainId || '0',
                type: this.radio
              });
            }
          })
        } else this._alert(res.msg,null,'error');
      },
      showInput() {
        this.inputVisible = true;
        this.$nextTick(_ => {
          this.$refs.saveTagInput.$refs.input.focus();
        });
      },

      handleInputConfirm() {
        let inputValue = this.inputValue;
        if (inputValue.includes(' ')) {
          this.$message.warning('标签名中请勿包含空格！')
          return
        }
        if (inputValue) {
          this.dynamicTags.push(inputValue);
        }
        this.inputVisible = false;
        this.inputValue = '';
      }
    }
  }
</script>
<style scoped lang="scss">
  .date-tag{
    border: 1px solid #ddd;
    border-radius: 5px;
    margin-right: 3px;
    padding: 7px 15px;
    cursor: pointer;
  }
  .date-tag.active{
    border: 1px solid var(--smtc-color-primary);
    color: var(--smtc-color-primary); 
  }
  .price-input {
    appearance: none;
    border: none;
    width: 100px;
    height: 30px;
    &:focus {
      outline: none;
    }
  }

  .price-label {
    background: var(--smtc-color-primary);
    color: #fff;
    height: 100%;
    display: inline-block;
  }

  .diaoHeight{
    max-height: 50vh;
    overflow-y: scroll
  }

  .dropCon{
    display: inline-block
  }

  .el-radio-group{
    width: 100%;
    .el-radio + .el-radio{
      margin-left: 0
    }
  }

  #allmap {
    height: 300px;
    overflow: hidden;
    margin: 1rem 1rem 0 0;
    font-family: "微软雅黑";
  }

  .priceTitle{
    label{
      width: 15%;
      display: inline-block;
      span{
        color: #999
      }
    }
    .el-input{
      width: 15%;
      margin-left: 5%;
      &:first-child{
        margin-left: 0
      }
    }
  }
</style>
